import { render, staticRenderFns } from "./ImportsScreen.vue?vue&type=template&id=4ce50458&scoped=true&"
import script from "./ImportsScreen.vue?vue&type=script&lang=js&"
export * from "./ImportsScreen.vue?vue&type=script&lang=js&"
import style0 from "./ImportsScreen.vue?vue&type=style&index=0&id=4ce50458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce50458",
  null
  
)

export default component.exports